
























import { Vue, Component, Watch } from 'vue-property-decorator';
import Breadcrumb from './Breadcrumb.vue';


@Component({
    components: { Breadcrumb },
})
export default class AppMain extends Vue {
    get key() {
        return this.$route.path + new Date();
    } 
}
